import compileSymbols from '~/utils/compileSymbols';

const types = [
  'CHANGE_SPOT_COLOR',
  'REMOVE_SPOT_COLOR',
  'ADD_SPOT_COLOR',
  'INVALID_FILE',
  'TOGGLE_PRODUCT_COLORS',
  'RESET_PROGRESS',
  'RESET_UPLOAD',
  'UPDATE_COLOR_MODE',
  'UPDATE_LAST_UPLOAD',
  'UPLOAD_COMPLETE',
  'UPLOAD_FAILED',
  'UPLOAD_IN_PROGRESS',
  'UPLOAD_SUCCESS',
  'UPLOAD_AND_SWAP',
  'ADD_RECENT_UPLOAD'
];

export default compileSymbols(types, 'upload');
